import { telephoneLisible } from '../../lib/listeAttente/telephone';

/**
 * Un numéro groupé comme on le dicte (`0479 32 38 50`), qui appelle d'un
 * clic quand il est sûr. Voir `telephoneLisible`.
 */
const Telephone = ({ numero, className }: { numero: string | null | undefined; className?: string }) => {
  const tel = telephoneLisible(numero);
  if (!tel) return <span className="text-gray-400">Pas de téléphone</span>;
  return tel.lien ? (
    <a href={tel.lien} className={className ?? 'tabular-nums hover:underline'}>{tel.texte}</a>
  ) : (
    <span className={className ?? 'tabular-nums'}>{tel.texte}</span>
  );
};

export default Telephone;
